<template>
  <div class="copyright-accordion">
    <button
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{ active: activeTab === index }"
      :disabled="activeTab === index"
      @click="activateTab(index)">
      <template v-if="tab.title.includes('/')">
        <span>{{ tab.title.split('/')[0] }}</span>
        <br>
        <span>{{ tab.title.split('/')[1] }}</span>
      </template>
      <template v-else>
        {{ tab.title }}
      </template>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    },
    belongsTo: {
      type: String,
      required: true,
    },
  },
  methods: {
    activateTab(index) {
      this.$emit('tab-clicked', { belongsTo: this.belongsTo, index })
    },
  },
}
</script>
